import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
// JIT compilation requires the compiler to be loaded in non-AOT builds.
// Importing the package as a side-effect ensures the JIT compiler is available.
import '@angular/compiler';
import { resolveAppVersion } from '@app/constants';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (
  environment.environment_name !== 'development' &&
  environment.environment_name !== 'local' &&
  environment.environment_name !== 'test'
) {
  const versionHeader = resolveAppVersion();
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    release: `medullar@${versionHeader}`,
    tracesSampleRate: environment.production ? 0.02 : 0.3,
    sampleRate: environment.production ? 0.5 : 0.8,
    environment: environment.environment_name,
    replaysSessionSampleRate: environment.production ? 0.01 : 0.1,
    replaysOnErrorSampleRate: environment.production ? 0.05 : 0.2,
    tracePropagationTargets: [
      'localhost',
      'https://api.medullar.com',
      'https://api.medullar.dev',
      'https://my.medullar.com',
      'https://my.medullar.dev',
    ],
    beforeSend(event) {
      // Example: drop errors from bots or synthetic traffic
      const ua = event.request?.headers?.['User-Agent'] || '';
      if (/HeadlessChrome|Pingdom|bot|crawler/i.test(ua)) return null;

      if (event.exception?.values?.some((v) => v.type === 'ChunkLoadError')) {
        return null;
      }

      if (event.exception?.values?.some((v) => v.value === 'Failed to fetch dynamically imported module')) {
        return null;
      }

      return event;
    },
  });
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
